import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { BoundDataType } from './def/bound-policy';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';

@Injectable({
  providedIn: 'root'
})
export class BoundPolicyService extends BaseContentService<BoundDataType> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, BoundPolicyService.staticBound);
  }

  get data$(): Observable<BoundDataType> {
    if (!this.loaded) {
      return this.getBoundPolicyData();
    }

    return of(this.data);
  }

  getBoundPolicyData(): Observable<BoundDataType> {
    const url = `${this.serviceBaseUrl}boundpolicy`;
    return this.get<BoundDataType>(url).pipe(
      map(data => {
        this.data = this.boundDataMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private boundDataMapper(data: BoundDataType): BoundDataType {
    if (!data) return;

    return data;
  }

  private static staticBound: BoundDataType = {
    pageName: 'boundpolicy',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      }
    ],
    grids: [
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: false,
        pageLength: null,
        searching: false,
        ordering: false,
        isCheckBoxRequired: false,
        responsive: false,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: false,
        allowPdfExport: false,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: false,
        pageLength: null,
        searching: false,
        ordering: false,
        isCheckBoxRequired: false,
        responsive: false,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: false,
        allowPdfExport: false,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: false,
        pageLength: null,
        searching: false,
        ordering: false,
        isCheckBoxRequired: false,
        responsive: false,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: false,
        allowPdfExport: false,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    tabLabels: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    sidemenu: [
      {
        name: '',
        iconClass: 'fa fa-globe',
        active: true,
        submenu: [
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: 'COVERAGES',
            image: null,
            displayItems: [
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              },
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: {
                  Alt: '',
                  Border: '',
                  Class: '',
                  Height: 70,
                  HSpace: 0,
                  Src: '',
                  VSpace: 0,
                  Width: 70,
                  MediaId: '',
                  Title: '',
                  Language: {
                    Name: 'en'
                  }
                },
                icon: ''
              }
            ]
          },
          {
            name: '',
            url: '',
            heading: '',
            image: null,
            displayItems: [
              {
                keyText: ' ',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              },
              {
                keyText: '',
                description: '',
                apiMappingKey: '',
                navigation: null,
                orderId: null,
                image: null,
                icon: ''
              }
            ]
          }
        ]
      }
    ],
    dropdown: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    buttons: [
      {
        keyText: 'UPLOAD'
      }
    ]
  };
}
